module.exports = __webpack_public_path__ + "img/product-service.67429d8b.png";